export class Block {
    name = "";
    avisBlock = false;
    key = "";
    condition;
    colType = "0"
    rows = [];
    columns = [];
    sourceForm?: string;
    sourceBlock?: boolean;
}
